var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column items-center"},[_c('p',{staticClass:"q-ma-none"},[_c('strong',[_vm._v(_vm._s(_vm.data.shipper.firstName)+" "+_vm._s(_vm.data.shipper.lastName))])]),_c('strong',[_c('p',{staticClass:"q-ma-none"},[_vm._v(_vm._s(_vm.phone))])]),_c('strong',[_c('p',{staticClass:"q-ma-none"},[_vm._v(_vm._s(_vm.data.shipper.email))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }